import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IntakeSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  marginTop: '8px',
}));
